import { useTranslation } from "react-i18next";
import { ChangeOrgTextField } from "./ChangeOrgTextField";

interface Props {
  currentValue: string;
}

export const ChangeContactEmail = ({ currentValue }: Props) => {
  const { t } = useTranslation();

  return (
    <ChangeOrgTextField
      currentValue={currentValue}
      fieldName="contactEmail"
      label={t("Contact email")}
      helperText={t("Please provide a contact email for your company")}
      toastMessage={t("Contact email has been updated!")}
      buildPatch={(value) => ({ contactEmail: { value } })}
      validation={{
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: t("Please provide a valid email address"),
        },
      }}
    />
  );
};
